import type { PiralPlugin } from 'piral-core';
import { AdminSettings } from './AdminSettings';
import * as actions from './actions';
import type { NavigationApi, RegisterNavigationItem } from './types';
import { withNavigationState } from './withNavigationState';

export function createNavigationApi(): PiralPlugin<NavigationApi> {
  return (context) => {
    context.defineActions(actions);

    context.dispatch((state) => ({
      ...state,
      registry: {
        ...state.registry,
        navigation: {
          items: [],
        },
      },
    }));
    let next = 0;

    return (api, target) => {
      const pilet = target.name ?? 'unknown';
      return {
        registerNavigationItem: (item: RegisterNavigationItem) => {
          const name = item.name ? item.name : String(next++);
          context.registerNavigationItem({ ...item, name, pilet });
          return () => api.unregisterNavigationItem(name);
        },
        // TODO: This is a temporary API to register settings items until we have a dedicated API for that.
        // The navigation extension will be used by the settings functions, so we can move this function to the settings extension/workflow once it is implemented.
        registerNavigationSettingsItem: (item) => {
          api.registerNavigationItem(AdminSettings);
          return api.registerNavigationItem({
            ...item,
            categoryName: AdminSettings.categoryName,
            parentName: AdminSettings.name,
          });
        },
        unregisterNavigationItem: (name) => {
          context.unregisterNavigationItem(name);
        },
        createNavigationConnector: () => {
          return (component) => withNavigationState(component);
        },
        setNavigationItemsTransformer: (transformer) => {
          context.setItemsTransformer(transformer);
        },
        setNavigationTreeTransformer: (transformer) => {
          context.setTreeTransformer(transformer);
        },
      };
    };
  };
}
